export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0011s_0000_Black-&-White-44.76cee82b.png";